import { useState } from "react";
import { Logo } from "./Logo";
import LegalModal from "./LegalModal";
import { Reveal, SectionHeader } from "./Reveal";
import { scrollToSection } from "./scroll";
import { useLang } from "@/i18n";

export default function Contact() {
  const { t } = useLang();
  const [legalOpen, setLegalOpen] = useState(false);
  const year = new Date().getFullYear();

  const channels = [
    { label: "Téléphone", value: "+590 690 32 47 77", href: "tel:+590690324777", id: "phone" },
    { label: "WhatsApp", value: "+590 690 32 47 77", href: "https://wa.me/590690324777", id: "whatsapp" },
    { label: "Email", value: "villamana971@gmail.com", href: "mailto:villamana971@gmail.com", id: "email" },
    { label: "Instagram", value: "@villamana971", href: "https://www.instagram.com/villamana971/", id: "instagram" },
  ];

  return (
    <footer
      id="contact"
      data-testid="contact-section"
      className="relative bg-pine/60 border-t gold-hairline"
    >
      <div className="mx-auto max-w-[1500px] px-5 sm:px-10 py-24 sm:py-28">
        <div className="grid lg:grid-cols-2 gap-16">
          <div>
            <SectionHeader eyebrow={t.contact.eyebrow} title={t.contact.title} />
            <Reveal delay={0.1}>
              <p className="mt-8 max-w-md text-sm sm:text-base text-mist font-light leading-relaxed">
                {t.contact.access}
              </p>
              <p className="mt-6 font-mono text-[0.65rem] uppercase tracking-[0.2em] text-sage leading-loose">
                {t.contact.address}
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-10 divide-y divide-[rgba(194,166,117,0.2)] border-y gold-hairline max-w-md">
                {channels.map((c) => (
                  <a
                    key={c.id}
                    href={c.href}
                    target={c.href.startsWith("http") ? "_blank" : undefined}
                    rel="noopener noreferrer"
                    data-testid={`contact-link-${c.id}`}
                    className="group flex items-center justify-between py-4 hover:bg-moss/40 transition-colors duration-300 px-2 -mx-2"
                  >
                    <span className="font-mono text-[0.6rem] uppercase tracking-[0.25em] text-sage">
                      {c.label}
                    </span>
                    <span className="text-sm text-bone group-hover:text-gold transition-colors">
                      {c.value}
                    </span>
                  </a>
                ))}
              </div>
            </Reveal>
          </div>

          <div className="flex flex-col justify-between">
            <Reveal delay={0.1}>
              <div className="clipped-frame">
                <img
                  src="https://static.wixstatic.com/media/a83414_94d0cf99843340d4a3d97f39f2e20d70f003.jpg/v1/fill/w_1200,h_800,q_85/a83414_94d0cf99843340d4a3d97f39f2e20d70f003.jpg"
                  alt="Villa Mana — vue sur la mer des Caraïbes"
                  loading="lazy"
                  data-testid="contact-photo"
                  className="w-full aspect-[3/2] object-cover"
                />
              </div>
            </Reveal>
            <Reveal delay={0.2}>
              <p className="font-mono text-[0.6rem] uppercase tracking-[0.3em] text-gold mt-10">
                {t.contact.follow}
              </p>
              <div className="mt-4 flex flex-wrap gap-x-8 gap-y-2">
                {["Instagram"].map((s, i) => (
                  <a
                    key={s}
                    data-testid={`footer-social-${i}`}
                    href="https://www.instagram.com/villamana971/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-display italic text-lg text-bone/80 hover:text-gold transition-colors"
                  >
                    {s}
                  </a>
                ))}
              </div>
            </Reveal>
          </div>
        </div>

        <div className="mt-24 pt-8 border-t gold-hairline flex flex-col sm:flex-row items-center justify-between gap-6">
          <div className="flex items-center">
            <Logo size={44} />
          </div>
          <div className="flex flex-col items-center gap-2">
            <p className="font-mono text-[0.55rem] uppercase tracking-[0.25em] text-sage text-center">
              © {year} Villa Mana · {t.contact.rights}
            </p>
            <button
              data-testid="footer-legal"
              onClick={() => setLegalOpen(true)}
              className="font-mono text-[0.55rem] uppercase tracking-[0.25em] text-sage hover:text-gold transition-colors"
            >
              {t.legal.title}
            </button>
          </div>
          <button
            data-testid="footer-back-top"
            onClick={() => scrollToSection("accueil")}
            className="font-mono text-[0.6rem] uppercase tracking-[0.25em] text-gold hover:text-goldlight transition-colors"
          >
            ↑ {t.contact.backTop}
          </button>
        </div>
      </div>
      <LegalModal open={legalOpen} onClose={() => setLegalOpen(false)} />
    </footer>
  );
}
